// menu-items/timesheet.js
import {
  IconClockHour4,
  IconClockCheck,
  IconClipboardList,
} from '@tabler/icons-react';

const icons = {
  IconClockHour4,
  IconClockCheck,
  IconClipboardList,
};

// ─── Timesheet — shown to ALL authenticated roles ──────────────────────────────
// Employees: can log their own hours (/timesheet)
// Managers/HR/Directors/DEV: additionally see the overview (/timesheet/overview)

const userRole = localStorage.getItem('userRole');

const timesheetSection = {
  id: 'timesheet',
  title: 'Timesheet',
  type: 'group',
  children: [
    {
      id: 'timesheet-entry',
      title: 'My Timesheet',
      type: 'item',
      url: '/timesheet',
      icon: icons.IconClockHour4,
      breadcrumbs: false,
    },
    // Overview is only shown to admins / managers
    ...(['MANAGER', 'HR', 'DIRECTOR', 'DEV'].includes(userRole)
      ? [
          {
            id: 'timesheet-overview',
            title: 'Timesheet Overview',
            type: 'item',
            url: '/timesheet/overview',
            icon: icons.IconClipboardList,
            breadcrumbs: false,
          },
        ]
      : []),
  ],
};

export default timesheetSection;
